export default () => import(/* webpackChunkName: 'coffee/app/invite-of-school' */ './InviteOfSchool');
